<template>
  <div>
    <button class="d-none" data-toggle="modal" data-target="#addBracket_Modal" ref="openBracketModalBtn"></button>

    <div class="modal fade" id="addBracket_Modal" role="dialog" aria-labelledby="addBracket_ModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header border-0">
            <div>
              <h6 class="modal-title" id="addBracket_ModalLabel">
                New Bracket
              </h6>
              <div class="products-list-shim p-0" v-if="!divisionName || divisionName === ''">
                <content-placeholders :rounded="true">
                  <content-placeholders-text :lines="1" />
                </content-placeholders>
              </div>
              <p class="modal-subtitle" v-else>{{ divisionName }}</p>
            </div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="closeModalBracket">
              <img src="../../assets/Svg/close.svg" alt="Close" />
            </button>
          </div>
          <div class="modal-body">
            <div class="row no-gutters">
              <div class="col-12">
                <div class="form-group">
                  <input type="text" class="form-control" id="bracketName" v-model="bracketName"
                    required :class="{
                      filled: bracketName,
                      'is-invalid': $v.bracketName.$error,
                      'is-valid': !$v.bracketName.$invalid,
                  }"/>
                  <span v-if="!$v.bracketName.required" class="invalid-tooltip">
                    Bracket name is required
                  </span>
                  <span class="placeholder">Bracket Name</span>
                </div>

                <div>
                  <div class="d-flex align-items-center justify-content-between">
                    <span class="custom-format">Custom Team Selection</span>
                    <toggle-button type="checkbox" class="m-0 p-0  d-flex justify-content-end" id="customFormat"
                      v-model="customTeamSelection" :value="customTeamSelection" :sync="true" :width="34" />
                  </div>
                  <span class="custom-format-description">
                    Choose specific teams for this bracket instead of including all.
                  </span>
                </div>

                <div v-if="customTeamSelection" class="row no-gutters mt-2">
                  <div class="col-12">
                    <div class="member-select position-relative">
                      <multiselect v-model="selectedTeams" :options="filteredTeamOptions" open-direction="bottom"
                        :multiple="true" :close-on-select="false" :searchable="false" :internal-search="false"
                        :clear-on-select="false" track-by="id" label="team.team_name" placeholder="Select Teams"
                        :options-limit="300" :max-height="600" :hide-selected="true" @scroll.stop class="select-friends"
                        :class="{ 'is-invalid': showErrors && (!selectedTeams || !selectedTeams.length) }">
                        <template slot="tag" slot-scope="{ option, remove }">
                          <span class="custom__tag">
                            <div class="custom__content">
                              <span class="user__name text-capitalize">{{ option.team.team_name }}</span>
                            </div>
                            <span class="custom__remove cursor-pointer" @click="remove(option)">
                              <img src="../../assets/Svg/close.svg" alt="" />
                            </span>
                          </span>
                        </template>

                        <template slot="noResult">
                          No matching teams found. Try refining your search!
                        </template>

                        <template slot="noOptions">
                          No teams available.
                        </template>

                        <template slot="option" slot-scope="{ option }">
                          <div class="option__desc">
                            <span class="text-capitalize">{{ option.team.team_name }}</span>
                          </div>
                        </template>
                      </multiselect>
                      <p v-if="showErrors && (!selectedTeams || selectedTeams.length < 2)" class="invalid-tooltip">
                        Please select at least 2 teams.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="mt-3">
                  <div class="form-group mt-2">
                    <textarea class="form-control" id="description" v-model="description" rows="1" required></textarea>
                    <span class="placeholder">Description</span>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="event-btns-wrapper pt-3 justify-content-end">
            <button type="button" class="btn btn-primary" block @click="addBracket"
              :disabled="isLoadingArray[0]">
              <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
              <div v-else><img class="mr-1" src="../../assets/Svg/save.svg" alt="save" />Save</div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import {
  required,
} from "vuelidate/lib/validators";

export default {
  name: "AddBracketModal",
  components: {
    Multiselect,
  },
  data() {
    return {
      divisionName: "",
      bracketName: "",
      customTeamSelection: false,
      allTeams: [],
      selectedTeams: [],
      description: "",
      selectedTournamentGuid: null,
      isLoading: false,
      showErrors: false,
      isLoadingArray: [],
    };
  },
  computed: {
    // This will filter the teams based on the search input in the multiselect
    filteredTeamOptions() {
      return this.allTeams;
    }
  },
  validations() {
    return {
      bracketName: { required },
    }
  },
  watch: {
    customTeamSelection(newVal) {
      if (newVal) {
        // Clear selections when custom mode is turned on
        this.selectedTeams = [];
      } else {
        // Pre-select all teams again when custom mode is off
        this.selectedTeams = [...this.allTeams];
        this.showErrors = false;
      }
    },
  },
  methods: {
    removeTeam(index) {
      this.selectedTeams.splice(index, 1);
    },
    async addBracket() {
      this.$v.$touch();

      const insufficientTeams = this.customTeamSelection && (!this.selectedTeams || this.selectedTeams.length < 2);

      if (this.$v.$pending || this.$v.$error || this.$v.$invalid || insufficientTeams) {
        if (insufficientTeams) {
          this.showErrors = true; // show validation errors
        }
        return;
      }
      this.$set(this.isLoadingArray, 0, true);
      const apiPayload = {
        bracket_name: this.bracketName,
        tournament_guid: this.selectedTournamentGuid,
        bracket_description: this.description,
        team_ids: this.selectedTeams.map(t => t.team_id)
      };

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}tournaments/brackets/createBracket`,
          apiPayload
        );

        if (response.data.statusCode === 200 || response.data.statusCode === 201) {
          var bracketGuid = response.data.data.bracket.guid;
          this.$refs.closeModalBracket.click();

          const currentPath = this.$route.path;
          // Example: Redirect based on route name or path
          if (currentPath.includes("/match-geni")) {
            this.$router.push({ name: "BracketPlay", params: { id: bracketGuid } });
          } else if (currentPath.includes("/bracket-play")) {
            this.$router.replace({
              name: this.$route.name,
              params: {
                id: bracketGuid
              }
            })
            this.$emit("RefreshBracketOnAdd");
          }
        } else {
          this.$alert("Failed to add bracket. Please try again.");
        }
      } catch (error) {
        console.error("Error adding bracket:", error);
        this.$alert("An error occurred while adding the bracket.");
      } finally {
        this.$set(this.isLoadingArray, 0, false);
        this.isLoading = false;
      }
    },
    resetForm() {
      this.$v.$reset();
      this.bracketName = "";
      this.customTeamSelection = false;
      this.selectedTeams = [];
      this.description = "";
      this.divisionName = "";
      this.allTeams = [];
      this.selectedTournamentGuid = null;
      this.showErrors = false;
    }
  },
  mounted() {
    this.$root.$on("openAddBracketModal", (data) => {
      this.resetForm();
      this.selectedTournamentGuid = data.selectedTournamentGuid;
      this.divisionName = data.selectedTournamentName;

      if (data.tournamentTeams && Array.isArray(data.tournamentTeams)) {
        this.allTeams = data.tournamentTeams;
        if (!this.customTeamSelection) {
          this.selectedTeams = [...this.allTeams];
        }
      }

      // Get a reference to the hidden button
      var elem = this.$refs.openBracketModalBtn;

      // Click the button to open the modal, just like in your Edit Game component
      if (elem) {
        elem.click();
      }
    });
  },
};
</script>